<div
  class="tablesContainerWrapper"
>
  <div
    class="tablesContainer"
  >
    <table
      class="wholeTableStyle"
      cellpadding="0"
    >
      <thead
        class="tableHeaderStyle"
      >
        <tr>
          <th
            [title]="headerLabel"
            *ngFor="let headerLabel of getAllHeaderLabels();"
          >
            <div
              class="headerCellContentStyle"
            >
              {{headerLabel}}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="tableBodyRowStyle"
          *ngFor="let singleRowData of getAllPlayersData(); index as i"
        >
          <td>
            <div
              class="bodyCellContentStyle"
            >
              #{{i + 1}}
            </div>
          </td>
          <td>
            <div
              class="bodyCellContentStyle"
            >
              <a
                href=""
                class="linkStyle"
                (click)="fullNameClickHandler($event)"
              >
                {{singleRowData.player_full_name}}
              </a>
            </div>
          </td>
          <td
            *ngFor="let balls of singleRowData.statistic"
          >
            <div
              class="bodyCellContentStyle"
              style="justify-content: center;"
            >
              <div
                class="bodyCellBallSquareContent"
              >
                {{balls || ''}}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
